import { call, put, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, passwordWarning } from "./actions"

//import { postFakeLogin, postJwtLogin } from "../../../helpers/backend_helper"
import { postJwtLogin } from "../../../helpers/backend_helper"
import { saveValues,removeValues,clearStore } from "../../../helpers/storagewrapper.js"

const moment = require('moment');

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user?.email?.toLowerCase()?.trim(),
        password: user.password,
      })
      console.log("response", response?.success)
      if (response?.success) {
        if (user?.rememberme) {
          saveValues("persistme", true,true)
          saveValues("authUser", JSON.stringify(response),true)
        } else {
          saveValues("persistme", false,true)
          saveValues("authUser", JSON.stringify(response),false)
        }
        
        yield put(loginSuccess(response))

        // Check whether admin needs to reset password
        let daysPassed = moment().diff(moment(response?.data?.passwordChangedAt) || moment(), 'days') // number of days passed from the day user last changed his password
        if (daysPassed >= Number(process.env.REACT_APP_PASSWORD_WARN_AGE)) {
          yield put(passwordWarning("Please change your password to retain access."))
        }
      } else {
        yield put(apiError(response?.error || "Login failed"))
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      })
      saveValues("persistme", true,true)
      saveValues("authUser", JSON.stringify(response),true)
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    removeValues("authUser")
    clearStore()
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeLatest(LOGIN_USER, loginUser)
  yield takeLatest(LOGOUT_USER, logoutUser)
}

export default authSaga
